export const DIRECT_SPEECH_CLEAR = 'DIRECT_SPEECH_CLEAR';
export const DIRECT_SPEECH_HIDE_OFFLINE_POPUP = 'DIRECT_HIDE_OFFLINE_POPUP';
export const DIRECT_SPEECH_SEND_START = 'DIRECT_SPEECH_SEND_START';
export const DIRECT_SPEECH_SEND_FINISH = 'DIRECT_SPEECH_SEND_FINISH';
export const DIRECT_SPEECH_SET_CALL_TO_ACTION = 'DIRECT_SPEECH_SET_CALL_TO_ACTION';
export const DIRECT_SPEECH_TOGGLE_GREETING = 'DIRECT_SPEECH_TOGGLE_GREETING';
export const DIRECT_SPEECH_TOGGLE_PRONOUNCE_TIME = 'DIRECT_SPEECH_TOGGLE_PRONOUNCE_TIME';
